import { Drawer } from '@economic/taco';
import React, { PropsWithChildren } from 'react';
import { HelpDrawerBackButton } from '~/app/components/Header/Help/HelpDrawerBackButton';
import { HelpDrawerActions } from '~/app/components/Header/Help/HelpDrawerActions';

export interface HelpDrawerViewProps {
    title: string | React.JSX.Element;
}

export function HelpDrawerView({ children, title }: PropsWithChildren<HelpDrawerViewProps>): React.JSX.Element {
    return (
        <>
            <Drawer.Title>
                <HelpDrawerBackButton>{title}</HelpDrawerBackButton>
                <HelpDrawerActions />
            </Drawer.Title>
            {children}
        </>
    );
}
